import { getIn } from "formik";
import FormControl from "@ds/components/FormControl";
import InputBase from "@ds/components/InputBase";
import { TFieldInput } from "./type";

const FieldInput: React.FC<TFieldInput> = ({
  label,
  name,
  id,
  type,
  hint,
  value,
  optional,
  placeholder,
  field,
  form,
  FormControlProps,
  ...InputBaseProps
}) => {
  const { touched, errors } = form;
  const { onChange, onBlur } = field;
  const isError = getIn(touched, field.name) && getIn(errors, field.name);

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const caret = event.target.selectionStart;
    const element = event.target;
    window.requestAnimationFrame(() => {
      element.selectionStart = caret;
      element.selectionEnd = caret;
    });
    onChange(event.target.value);
  };

  return (
    <FormControl
      label={label}
      hint={hint}
      error={isError}
      id={id}
      optional={optional}
      form={form}
      field={field}
      {...FormControlProps}
    >
      <InputBase
        dataTestID="input-test"
        type={type}
        name={name}
        value={value}
        onBlur={onBlur}
        placeholder={placeholder}
        onChange={inputChange}
        {...field}
        {...InputBaseProps}
      />
    </FormControl>
  );
};

export default FieldInput;
